import React from "react";

import { Button } from "/component/base";
import Alert from "/component/base/Alert";
import { useRouterDispatch } from "/component/provider/RedirectListenerProvider";
import { useTranslation } from "/hook";

import { Props } from "./CustomPrompt.types";

const CustomPrompt = ({ setConfirm, confirmCallback }: Props) => {
  const { t } = useTranslation("partial-customPrompt");
  const { dispatch } = useRouterDispatch();

  const allowTransition = () => {
    setConfirm(false);
    confirmCallback(true);
    dispatch(true);
  };

  const blockTransition = () => {
    setConfirm(false);
    confirmCallback(false);
    dispatch(false);
  };

  return (
    <Alert
      close={() => undefined}
      footer={
        <>
          <Button fullWidth="flex" onClick={allowTransition}>
            {t("confirmLabel")}
          </Button>
          <Button variant="secondary" fullWidth="flex" onClick={blockTransition}>
            {t("cancelLabel")}
          </Button>
        </>
      }
      title={t("title")}
      isOpen={true}
    >
      {t("subtitle")}
    </Alert>
  );
};

export default CustomPrompt;
